import React from "react";
import { Alert, Descriptions, Typography } from "antd";
import { Modal } from "../../components/Common";

const { Text, Paragraph } = Typography;

/**
 * Shows a freshly issued temporary password. The server only ever stores its hash,
 * so this dialog is the single opportunity to copy it — hence the warning and the
 * lack of any "show again" affordance.
 */
const CredentialsModal = ({ credentials, onClose, title = "Temporary credentials" }) => (
  <Modal open={Boolean(credentials)} onClose={onClose} title={title} cancelText="Done">
    {credentials && (
      <>
        <Alert
          type="warning"
          showIcon
          style={{ marginBottom: 16 }}
          message="Copy this password now"
          description="It is stored only as a hash and cannot be shown again. The user must change it at first sign-in."
        />

        <Descriptions column={1} size="small" bordered>
          <Descriptions.Item label="Username">
            <Text copyable>{credentials.username}</Text>
          </Descriptions.Item>
          <Descriptions.Item label="Temporary password">
            <Text copyable code>
              {credentials.temporaryPassword}
            </Text>
          </Descriptions.Item>
          <Descriptions.Item label="Role">{credentials.role}</Descriptions.Item>
        </Descriptions>

        <Paragraph style={{ marginTop: 16, marginBottom: 0 }}>
          {credentials.emailSent ? (
            <Text type="success">The credentials were also emailed to the account address.</Text>
          ) : (
            <Text type="secondary">
              {credentials.emailError
                ? `Not emailed: ${credentials.emailError}`
                : "Not emailed — pass the password on through a secure channel."}
            </Text>
          )}
        </Paragraph>
      </>
    )}
  </Modal>
);

export default CredentialsModal;
